import { FC } from 'react'

export const OkxAffiliateProvider: FC = ({ children }) => {
  return <>{children}</>
}

//empty commit 29
